module.exports = __webpack_public_path__ + "static/gray2-c334deea59909001e01c44b0bf582408.png";